module.exports = __webpack_public_path__ + "static/media/news4.9fd04565.png";